module.exports = __webpack_public_path__ + "img/loading.260a0f49.gif";